import {
  Relationships
} from '../../constants';

const mapRelationshipValue = (relation) => {
  const getType = Object.keys(Relationships).find(
    (key) => Relationships[key].type === relation.type
  );

  const rel = Relationships[getType];

  if (!rel?.value) {

    return rel.step
    ? relation.attributes[rel.step]
    : relation.attributes;
  }

  return rel.step
    ? relation.attributes[rel.step][rel.value]
    : relation.attributes[rel.value];
};

export const mapRelationships = (
   obj,
   included,
   listRelationships = false
) => {

  return Object.keys(obj).flatMap((key) => {
    return included.flatMap((rel) => {

      if (Array.isArray(obj[key]?.data) && listRelationships) {

        let relList = [];

        for (const item of obj[key]?.data) {

          if (item && item.id === rel.id) {

            relList.push(
              {
                id: rel.id,
                type: rel.type,
                field: key,
                value: mapRelationshipValue(rel)
              }
            );
          }
        }

        return relList;
      }

      if (obj[key].data && obj[key].data.id === rel.id) {

        return {
          id: rel.id,
          type: rel.type,
          field: key,
          value: mapRelationshipValue(rel)
        };
      }
      return [];
    });
  });
};
